import { jsx, jsxs } from "react/jsx-runtime";
import { Field } from "@base-ui/react/field";
import { forwardRef } from "react";
import { cn } from "../../utils/cn.js";
import { CdnIcon } from "../CdnIcon/index.js";
import { Tooltip } from "../Tooltip/index.js";
const InputButtonWrapper = /*#__PURE__*/ forwardRef(({ styles, iconLeft, iconRight, handleButtonClick, isDisabled = false, buttonText, errorMessage, tooltipSideOffset = 0, label, isLabelHidden, isToggled = false, ...props }, ref)=>/*#__PURE__*/ jsxs("button", {
        ...props,
        type: "button",
        onClick: handleButtonClick,
        "aria-disabled": isDisabled,
        "aria-pressed": isToggled,
        disabled: isDisabled,
        className: cn(styles.buttonWrapper()),
        ref: ref,
        children: [
            iconLeft ? /*#__PURE__*/ jsx("div", {
                className: styles.iconLeft(),
                children: /*#__PURE__*/ jsx(CdnIcon, {
                    iconName: iconLeft,
                    size: "24"
                })
            }) : null,
            /*#__PURE__*/ jsxs("div", {
                className: styles.buttonText(),
                children: [
                    isLabelHidden ? null : /*#__PURE__*/ jsx("span", {
                        className: styles.labelSlot(),
                        children: label
                    }),
                    buttonText ? /*#__PURE__*/ jsx("span", {
                        className: styles.sublabelSlot(),
                        children: buttonText
                    }) : null
                ]
            }),
            /*#__PURE__*/ jsx(Field.Error, {
                match: !!errorMessage,
                className: styles.errorTextSlot(),
                "aria-live": "assertive",
                children: /*#__PURE__*/ jsx(Tooltip, {
                    defaultOpen: true,
                    open: !!errorMessage,
                    emphasis: "bold",
                    sideOffset: tooltipSideOffset,
                    color: "error",
                    align: "end",
                    side: "bottom",
                    hideCloseButton: true,
                    triggerNode: /*#__PURE__*/ jsx(CdnIcon, {
                        iconName: "error",
                        size: "20"
                    }),
                    children: /*#__PURE__*/ jsx("div", {
                        children: errorMessage
                    })
                })
            }),
            iconRight ? /*#__PURE__*/ jsx("div", {
                className: styles.iconRight(),
                children: /*#__PURE__*/ jsx(CdnIcon, {
                    iconName: iconRight,
                    size: "20"
                })
            }) : null
        ]
    }));
export { InputButtonWrapper };
